module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-6@3x.jpg?9fdb82a6";